import { css } from 'linaria';

export const swiperStyle = css`
  &&& {
    padding-bottom: 15px;
    margin-bottom: -15px;

    @media (--from-tablet) {
      justify-content: flex-start;
      width: 100%;
      padding: 15px 0;
      margin: -15px 0;
    }

    .swiper-button-prev,
    .swiper-button-next {
      @media (--only-tablet) {
        display: flex;
      }
    }

    .swiper-wrapper {
      justify-content: flex-start;
    }
  }
`;

export const swiperStyleB = css`
  
`;

export const otherSectionStyle = css`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 80px 0;
  margin: 0 auto;
  background-color: var(--background-secondary);

  @media (--to-desktop) {
    padding: 64px 0;
  }
`;

export const otherSectionLayout = css`
  display: block;
`;

export const otherSectionTitle = css`
  margin-bottom: 24px;

  @media (--only-mobile) {
    margin-bottom: 16px;
  }
`;

export const swiperSlideStyle = css`
  && {
    width: 377px;
    height: unset;
    margin-right: 24px;

    &:last-of-type {
      margin-right: 0;
    }

    @media (--only-desktop) {
      width: 297px;
    }

    @media (--only-tablet) {
      width: 209px;
      margin-right: 16px;
    }

    @media (--only-mobile) {
      width: 204px;
      margin-right: 16px;
    }
  }
`;

export const swiperSlideStyleB = css`
  && {
    width: 381px;
    height: unset;
    margin-right: 16px;

    &:first-of-type {
      img {
        border-radius: var(--rounding-xl) 0 0 var(--rounding-xl);
      }
    }

    &:last-of-type {
      margin-right: 0;
      img {
        border-radius: 0 var(--rounding-xl) var(--rounding-xl) 0;
      }
    }

    @media (--only-desktop) {
      width: 302px;
    }

    @media (--only-tablet) {
      width: 204px;
      margin-right: 24px;
    }

    @media (--only-mobile) {
      width: 277px;
      margin-right: 8px;
    }
  }
`;

export const otherSectionLink = css`
  height: 100%;  
`;

export const otherSectionLinkWithHover = css`
  &:hover {
    box-shadow: var(--box-shadow-m);
  }
`;

